// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"20184526","213":"decbdc27","239":"91027f7e","248":"a1809291","249":"a6f9781b","453":"1cba7f9c","455":"6dcd6cdd"}[chunkId] + ".chunk.js";
};